// extracted by mini-css-extract-plugin
module.exports = {"CustomOverlay":"CustomWithSpinner_CustomOverlay__2KaBd","SpinnerContainer":"CustomWithSpinner_SpinnerContainer__2KYDO"};